var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, LinearProgress } from '@mui/material';
import { offerList as offerListApi, offerListForumMessage as api, } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { getCurrentUser } from '../../localStorage';
import PageLayout from '../atoms/PageLayout';
import ForumMessages from '../organisms/ForumMessages';
import { useTypicaTranslation } from '../../hooks/useTypicaTranslation';
var messageReducer = function (messages, action) {
    switch (action.type) {
        case 'setAll':
            return __spreadArray([], action.messages, true);
        case 'create':
            return __spreadArray(__spreadArray([], messages, true), [action.message], false);
        case 'remove':
            return messages.filter(function (message) { return message.id !== action.id; });
        case 'set': {
            var index = messages.findIndex(function (message) { return message.id === action.message.id; });
            if (index === -1) {
                return messages;
            }
            var newMessages = __spreadArray([], messages, true);
            newMessages[index] = action.message;
            return newMessages;
        }
    }
};
var OfferListForumMesssagesPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var currentUser = getCurrentUser();
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useReducer(messageReducer, []), messages = _c[0], dispatch = _c[1];
    var _d = React.useState(), offerList = _d[0], setOfferList = _d[1];
    var translate = useTypicaTranslation().translate;
    var getAll = useRequest(api.getAll);
    var getOfferList = useRequest(offerListApi.get);
    var createMessage = useRequest(api.create);
    var updateMessage = useRequest(api.update);
    var deleteMessage = useRequest(api.deleteMessage);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var offerListResponse, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getOfferList({ id: id })];
                    case 1:
                        offerListResponse = _a.sent();
                        if (canceled || !offerListResponse)
                            return [2 /*return*/];
                        setOfferList(offerListResponse);
                        return [4 /*yield*/, getAll(id)];
                    case 2:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setLoading(false);
                        dispatch({ type: 'setAll', messages: response });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getAll, getOfferList, id]);
    var handleCreate = React.useCallback(function (attributes) {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, createMessage({
                            offerListId: id,
                            offer_list_forum_message: {
                                body: attributes.body,
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response)
                            return [2 /*return*/];
                        dispatch({ type: 'create', message: response });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [createMessage, id]);
    var handleDelete = React.useCallback(function (messageId) {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deleteMessage({ id: messageId, offerListId: id })];
                    case 1:
                        _a.sent();
                        dispatch({ type: 'remove', id: messageId });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [deleteMessage, id]);
    var handleUpdate = React.useCallback(function (messageId, body) {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, updateMessage({
                            id: messageId,
                            offerListId: id,
                            offer_list_forum_message: { body: body },
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response)
                            return [2 /*return*/];
                        dispatch({ type: 'set', message: response });
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [id, updateMessage]);
    if (loading || !offerList)
        return React.createElement(LinearProgress, null);
    return (React.createElement(Container, { maxWidth: "md" },
        React.createElement(PageLayout, { backLink: true, title: offerList.name },
            React.createElement(ForumMessages, { messages: messages, currentUser: currentUser, createMessage: handleCreate, deleteMessage: handleDelete, updateMessage: handleUpdate, translateMessage: translate }))));
};
export default OfferListForumMesssagesPage;
